import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "../pages/Login";
import LoanApplication from "../pages/loan_app";
import Dashboard from "../pages/loan_app/dashboard/dashboard";
import LoanDashboard from "../pages/LoanDashboard";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
  withMsal,
} from "@azure/msal-react";
import SAMLSSO from "../components/saml_sso";
import { BASE_PATH } from "../constants";
import { getAccessToken } from "../helpers";
import SessionTimeout from "../components/session/SessionTimeout";
import { extendSession } from "../helpers/loginHelpers";
import LoginRedirect from "../pages/Login/loginRedirect";
import Notfound from "../components/notfound";
import RefinanceHome from "../refinance";
import coapplicant from "../pages/loan_app/coapplicant/coapplicant";

const MainRoutes = (props) => {
  const { instance } = useMsal();
  let [token, setToken] = useState(getAccessToken());
  const urlParams = new URLSearchParams(window.location.search);

  // useEffect(() => {
  //   const fullPath = window.location.pathname; // Get the full pathname
  //   let basePath = BASE_PATH; // Get the base path
  //   if(fullPath.includes(`${BASE_PATH}app`)) {
  //     basePath = `${BASE_PATH}app`; // Get the base path with "/app"
  //   }
  //   if(fullPath.includes(`${BASE_PATH}dashboard`)) {
  //     basePath = `${BASE_PATH}dashboard`; // Get the base path with "/dashboard"
  //   }
  //   const pathAfterCx = fullPath.split(basePath)[1]; // Split and get the part after "/cx/"
  //   // Check if there is a query string
  //   const queryIndex = window.location.href.indexOf('?');
  //   const pathToStore = queryIndex > -1 ? pathAfterCx + window.location.search : pathAfterCx;
  //   if(pathToStore) {
  //     localStorage.setItem('requiredPath', pathToStore);
  //   }
  // }, []);
  useEffect(() => {
    const getRequiredPath = localStorage.getItem("requiredPath");
    const fullPath = window.location.pathname; // Get the full pathname
    let basePath = BASE_PATH; // Initialize base path

    // Determine the appropriate base path based on the full path
    if (fullPath.includes(`${BASE_PATH}app`)) {
        basePath = `${BASE_PATH}app`;
    } else if (fullPath.includes(`${BASE_PATH}dashboard`)) {
        basePath = `${BASE_PATH}dashboard`;
    }

    // Get the part of the path after the base path
    const pathAfterCx = fullPath.split(basePath)[1] || '';

    
    // Construct the full path including the query string
    const pathToStore = pathAfterCx + window.location.search;
    
    // Use URLSearchParams to parse the query parameters
    const urlParams = new URLSearchParams(new URL(window.location.href).search);
    
    // Check for valid path conditions
    const validPath = urlParams.has('lar') || 
                      urlParams.has('authentication');

    const getRequiredPathValues = new URLSearchParams(getRequiredPath);
    const cxUrlParamsPath = new URLSearchParams(window.location.search);
    const cx_access_token = localStorage.getItem("cx_access_token");
    if(getRequiredPathValues.has('authentication') && cxUrlParamsPath?.size === 0 && cx_access_token !== null) {
      localStorage.removeItem('requiredPath');
    }
    if (validPath) {
      if(localStorage.getItem('requiredPath') !== pathToStore && getRequiredPath !== null) {
        localStorage.setItem('previousPath', getRequiredPath)
      }
      localStorage.setItem('requiredPath', pathToStore);
    } else if(!(localStorage.getItem('requiredPath'))) {
        localStorage.removeItem('requiredPath');
    } 
  }, []);

  // useEffect(() => {
  //   const checkSizeAndRedirect = () => {
  //     const screenWidth = window.innerWidth;
 
    //   const thresholdWidth = 768;
    //   if (screenWidth < thresholdWidth) {
    //     const queryParams = window.location.search;
    //     window.location.href = `${process.env.REACT_APP_SERVER_URL}/cx-pwa/${queryParams}`;
    //   }
    // };
    // const excludedRoutes = [process.env.REACT_APP_SAML_URL];
    // const currentPath = window.location.pathname;
 
  //   if (!excludedRoutes.includes(currentPath)) {
  //     checkSizeAndRedirect();
  //     window.addEventListener('resize', checkSizeAndRedirect);
  //   }
 
  //   return () => {
  //     window.removeEventListener('resize', checkSizeAndRedirect);
  //   };
  // }, [window.location.pathname]);

  useEffect(() => {
    if(urlParams.has('lar')) {
      window.localStorage.setItem('lar', urlParams.get('lar'));
    }
  }, [urlParams]);

  function signOutClickHandler() {
    const logoutRequest = {
      account: instance.getAccountByHomeId(
        window.localStorage.getItem("home_account_id")
      ),
      postLogoutRedirectUri: BASE_PATH
    };
   
    const getLarFromLocalStorage = localStorage.getItem("lar");
    const getAppLanguage = localStorage.getItem("i18nextLng");
    const getRequiredPath = localStorage.getItem("requiredPath");
    window.localStorage.clear();
    if(getLarFromLocalStorage !== null) {
      window.localStorage.setItem('lar', getLarFromLocalStorage);
    }
    if(getAppLanguage !== null) {
      window.localStorage.setItem("i18nextLng", getAppLanguage);
    }
    if(getRequiredPath !== null) {
      window.localStorage.setItem("requiredPath", getRequiredPath);
    }
    window.sessionStorage.clear();
    setToken(null);
    instance.logoutRedirect(logoutRequest);
  }

  return (
    <div>
      {token && (
        <SessionTimeout
          logout={() => signOutClickHandler()}
          extendSession={() =>
            extendSession({ props, setToken: (token) => setToken(token) })
          }
          setToken={(token) => setToken(token)}
        />
      )}

      <Router>
        <Routes>
          <Route
            path={process.env.REACT_APP_LOAN_APPLN_URL}
            element={
              <div>
                <AuthenticatedTemplate>
                  <LoanApplication />
                </AuthenticatedTemplate>
                <UnauthenticatedTemplate>
                  <LoginRedirect
                    setToken={(token) => {
                      setToken(token);
                    }}
                  />
                </UnauthenticatedTemplate>
              </div>
            }
          />
          <Route
            path={process.env.REACT_APP_DASHBOARD_URL}
            element={
              <div>
                <AuthenticatedTemplate>
                  <LoanDashboard />
                </AuthenticatedTemplate>
                <UnauthenticatedTemplate>
                  <LoginRedirect
                    setToken={(token) => {
                      setToken(token);
                    }}
                  />
                </UnauthenticatedTemplate>
              </div>
            }
          />

          <Route
            path={process.env.REACT_APP_SAML_URL}
            element={
              <div>
                <AuthenticatedTemplate>
                  <SAMLSSO />
                </AuthenticatedTemplate>
                <UnauthenticatedTemplate>
                  <LoginRedirect
                    call={(token) => {
                      setToken(token);
                    }}
                  />
                </UnauthenticatedTemplate>
              </div>
            }
          />

          <Route
            path={process.env.REACT_APP_BASE_URL}
            element={
              <div>
                <AuthenticatedTemplate>
                  <Dashboard />
                </AuthenticatedTemplate>
                <UnauthenticatedTemplate>
                  <LoginRedirect
                    call={(token) => {
                      setToken(token);
                    }}
                  />
                </UnauthenticatedTemplate>
              </div>
            }
          />

          <Route
            path={process.env.REACT_APP_REFINANCE_URL}
            element={<RefinanceHome />}
          />

          <Route path={`*`} element={<Notfound />} />
        </Routes>
      </Router>
    </div>
  );
};
export default withMsal(MainRoutes);
